import { tryCatch } from "@/lib/try-catch";
import { Ok, Err } from "ts-results";
import { API_BASE_URL } from "@/lib/constants";
import { Response } from "./types";
import * as z from "zod";

export const registerUserSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, "El correo electrónico es requerido")
    .email("Ingrese un correo electrónico válido"),
  firstName: z
    .string()
    .trim()
    .min(1, "El nombre es requerido"),
  secondName: z
    .string()
    .trim()
    .optional(),
  thirdName: z
    .string()
    .trim()
    .optional(),
  password: z
    .string()
    .trim()
    .min(1, "La contraseña es requerida")
    .min(6, "La contraseña debe tener al menos 6 caracteres"),
});

export type RegisterUserRequest = z.infer<typeof registerUserSchema>;

export async function registerUser(userData: RegisterUserRequest): Promise<Response<string>> {
  const responseResult = await tryCatch(fetch(`${API_BASE_URL}/api/v1/registracion`, {
    method: 'POST',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userData),
  }));

  if (responseResult.err) {
    return Err({
      message: `Error al consultar el servidor: ${responseResult.val.message}`,
      devMessage: responseResult.val.message,
    });
  }

  const response = responseResult.val;
  
  if (!response.ok) {
    const errorMessageResult = await tryCatch(response.json());
    return errorMessageResult.err ? 
      Err({
        message: `Error al registrarse: ${errorMessageResult.val.message}`,
        devMessage: errorMessageResult.val.message,
      }) : 
      Err({
        message: errorMessageResult.val.message,
        devMessage: errorMessageResult.val.devMessage,
      });
  }
  
  const dataResult = await tryCatch(response.text());

  if (dataResult.err) {
    return Err({
      message: `Error al leer la respuesta del servidor: ${dataResult.val.message}`,
      devMessage: dataResult.val.message,
    });
  }

  return Ok(dataResult.val);
} 